// extracted by mini-css-extract-plugin
module.exports = {"component":"details_component_1Wd9S","content":"details_content_3bNYs","poster":"details_poster_1fM1a","rating":"details_rating_3jL6Q","overview":"details_overview_2pN1M"};